import { ref } from 'vue'

const isOpen = ref(false)

export function useInstallOverlay() {
  function openInstallOverlay() {
    isOpen.value = true
  }

  function closeInstallOverlay() {
    isOpen.value = false
  }

  return {
    isOpen,
    openInstallOverlay,
    closeInstallOverlay
  }
}
